import { webDomain } from '@evolutivelabs/rhinoshield-shopify-client'

const officialPage = `https://${webDomain}`

export function redirectUrl(url: string): void {
  window.location.href = url
}

export function redirectUrlWithNewWindow(url: string): void {
  window.open(url)
}

export function redirectOfficialPage(): void {
  redirectUrl(officialPage)
}

export function redirectOfficialCartPage(): void {
  redirectUrl(`${officialPage}/cart`)
}
